import { bind as bound } from 'bind-decorator';
import { observer } from 'mobx-react';
import type { ComponentType } from 'react';
import React, { Component } from 'react';
import type FormStore from 'tm3-core/controls/forms/form-store';
import { FormContext } from './Form';

export type GenericProps<T> = {
  for: keyof T;
  onChange?: (e: any, key: string) => void;
};

export function GenerateComponentType<T, P>(
  RawComponent: ComponentType<P>,
  onChangeMethodName: string = 'onChange'
) {
  class GenericComponent extends Component<P & GenericProps<T>> {
    static contextType = FormContext;
    get form(): FormStore<T> {
      return this.context;
    }

    @bound
    getValue(fallback: any = ''): any | string {
      const { for: key } = this.props;
      const value = this.form.get(key);
      if (value === undefined) return fallback;
      return value;
    }

    @bound
    onChange(e: any) {
      const { onChange, for: key } = this.props;
      if (!!onChange) {
        return onChange(e, key != null ? key.toString() : '');
      }
      if (key == null) return;
      this.form[onChangeMethodName](key, null, e);
    }
    render() {
      const { isSubmitted, validationResults } = this.context;

      const { for: key, ...other } = this.props;
      const { getValue, onChange } = this;
      let value = { value: getValue(), checked: undefined };
      if (onChangeMethodName === 'onCheckboxChange') {
        // gross hack
        value = { checked: getValue(false) };
      }
      let errorText;
      try {
        errorText = (validationResults[key] || []).join(',');
      } catch (e) {
        // hide exception - seemingly this.validationResults[key] can return "Error"
      }
      return (
        <RawComponent
          name={key}
          {...value}
          submitted={isSubmitted}
          errorText={errorText}
          {...other} // doing other after value allows the value to be overriden by props (unsure if useful)
          onChange={this.onChange}
        />
      );
    }
  }
  return observer(GenericComponent);
}
